import React, { useEffect, useRef, useState } from 'react';
import MakeTimeStamp from './util/makeTimeStamp';
import RandomStringFunc from './util/randomStringFunc';

const testURL = "https://stgstdpay.inicis.com/stdjs/INIStdPay.js";
const releaseURL = "https://stdpay.inicis.com/stdjs/INIStdPay.js";

const payServerText = (index: number) => {
  switch (index) {
    case 0: return "Card";
    case 1: return "VBank";
    case 2: return "HPP";
    case 3: return "DirectBank";
    default: return "Card";
  }
};

const payServerTextMb = (index: number) => {
  switch (index) {
    case 0: return "CARD";
    case 1: return "VBANK";
    case 2: return "MOBILE";
    case 3: return "BANK";
    default: return "CARD";
  }
};

interface Props {
  payData: any;
  isPurchase: number;
  isTest: boolean;
}

const ReactInicis: React.FC<Props> = ({ payData, isPurchase, isTest }) => {
  const mobilePurchaseRef = useRef<HTMLFormElement | null>(null);

  useEffect(() => {
    if (!isPurchase) return;
    const isReady =
        payData?.mKey &&
        payData?.signature &&
        payData?.timestamp &&
        payData?.oid &&
        payData?.buyerName &&
        payData?.buyerEmail &&
        payData?.buyerTel &&
        payData?.productName &&
        payData?.productPrice > 0 &&
        payData?.returnUrl;

    if (isReady) {
      // openPaymentPopup();
      onClickPurchase();
    }
  }, [isPurchase, payData?.mKey]);


  const openPaymentPopup = () => {
    if (!payData) return;

    console.log('//dd',{
      productName: payData.productName || '',
      buyerName: payData.buyerName || '',
      buyerEmail: payData.buyerEmail || '',
      buyerTel: payData.buyerTel || '',
      mid: payData.mid || '',
      gopaymethod: payServerText(payData.payStatus || 0),
      mKey: payData.mKey || '',
      signature: payData.signature || '',
      productPrice: String(payData.productPrice || 0),
      oid: payData.oid || '',
      timestamp: payData.timestamp || '',
      verification: payData.verification || '',
      acceptmethod: payData.acceptmethod || '',
      telStatus: payData.telStatus || '',
      returnUrl: payData.returnUrl || '',
      closeUrl: payData.closeUrl || '',
      payStatus: String(payData.payStatus || 0),
    })


    const query = new URLSearchParams({
      productName: payData.productName || '',
      buyerName: payData.buyerName || '',
      buyerEmail: payData.buyerEmail || '',
      buyerTel: payData.buyerTel || '',
      mid: payData.mid || '',
      gopaymethod: payServerText(payData.payStatus || 0),
      mKey: payData.mKey || '',
      signature: payData.signature || '',
      productPrice: String(payData.productPrice || 0),
      oid: payData.oid || '',
      timestamp: payData.timestamp || '',
      verification: payData.verification || '',
      acceptmethod: payData.acceptmethod || '',
      telStatus: payData.telStatus || '',
      returnUrl: payData.returnUrl || '',
      closeUrl: payData.closeUrl || '',
      payStatus: String(payData.payStatus || 0),
    }).toString();

    const paymentUrl = `https://hometownad.co.kr/v1/advertiser/payment/launch2?${query}`;
    window.location.href = paymentUrl
    // const popup = window.open(paymentUrl, 'popupWindow', 'width=500,height=700');
    // window.open(paymentUrl, '_blank');
  };


  const onClickPurchase = () => {

    const body = document.querySelector("body");

    // PC
    if (body && body.offsetWidth > 1024) {
      const agt = navigator.userAgent.toLowerCase();
      const script = document.createElement("script");
      script.src = releaseURL;
      document.head.appendChild(script);

      script.onload = (e: any) => {
        try {
          const stdPay = (e?.target || e?.srcElement).ownerDocument.defaultView.INIStdPay;
          console.log('//stdPay',stdPay)
          stdPay.pay('SendPayForm_id');
        } catch (err) {
          console.error('이니시스 스크립트 실행 실패', err);
        }
      };
    } else {
      // MOBILE
      if (mobilePurchaseRef.current) {
        mobilePurchaseRef.current.action = "https://mobile.inicis.com/smart/payment/";
        mobilePurchaseRef.current.target = "_self";
        mobilePurchaseRef.current.submit();
      }
    }
  };

  return (
      <div >
        {/* PC 결제 */}
        <form id="SendPayForm_id" method="Post">
          <input type="hidden" name="goodname" value={payData.productName || ''}/>
          <input type="hidden" name="buyername" value={payData.buyerName || ''}/>
          <input type="hidden" name="buyertel" value={payData.buyerTel || ''}/>
          <input type="hidden" name="buyeremail" value={payData.buyerEmail || ''}/>
          <input type="hidden" name="mid" value={payData.mid || ''}/>
          <input type="hidden" name="gopaymethod" value={payServerText(payData.payStatus || 0)}/>
          <input type="hidden" name="mKey" value={payData.mKey || ''}/>
          <input type="hidden" name="signature" value={payData.signature || ''}/>
          <input type="hidden" name="price" value={payData.productPrice || ''}/>
          <input type="hidden" name="oid" value={payData.oid || ''}/>
          <input type="hidden" name="timestamp" value={payData.timestamp || ''}/>
          <input type="hidden" name="verification" value={payData.verification || ''}/>
          <input type="hidden" name="version" value="1.0"/>
          <input type="hidden" name="currency" value="WON"/>
          {payData.acceptmethod && <input type="hidden" name="acceptmethod" value={payData.acceptmethod}/>}
          {payData.payStatus === 2 &&
              <input type="hidden" name="acceptmethod" value={`centerCd(Y):HPP(${payData.telStatus})`}/>}
          <input type="hidden" name="returnUrl" value={payData.returnUrl || ''}/>
          <input type="hidden" name="closeUrl" value={payData.closeUrl || ''}/>
        </form>

        {/* MOBILE 결제 */}
        <form name="mobileweb" method="post" acceptCharset="euc-kr" ref={mobilePurchaseRef}>
          <input type="hidden" name="P_NEXT_URL" value={payData.returnUrl || ''} />
          <input type="hidden" name="P_INI_PAYMENT" value={payServerTextMb(payData.payStatus || 0)} />
          <input type="hidden" name="P_MID" value={isTest ? "INIpayTest" : payData.mid || ''} />
          <input type="hidden" name="P_OID" value={payData.oid} />
          <input type="hidden" name="P_GOODS" value={payData.productName || ''} />
          <input type="hidden" name="P_AMT" value={payData.productPrice || ''} />
          <input type="hidden" name="P_UNAME" value={payData.buyerName || ''} />
          {payData.payStatus === 2 && <input type="hidden" name="P_HPP_METHOD" value={payData.telStatus || '2'} />}
        </form>
      </div>
  );
};

export default ReactInicis;
